// import React, { useState, useRef, useEffect } from "react";
// import DropDownIcon from "../../../Assets/Images/CreateBatch/icon-dropdown-menu.png";
// export default function DropDown({
//   width,
//   label,
//   selected,
//   setSelected,
//   options,
//   customWidth,
//   customTop,
//   isRequired,
//   style,
//   className,
// }) {
//   const [isActive, setIsActive] = useState(false);
//   const [selectedLabel, setSelectedLabel] = useState("");
//   const dropdownRef = useRef(null);

//   // Update label by checking if selected is an object or primitive
//   useEffect(() => {
//     let selId;
//     if (selected && typeof selected === "object") {
//       selId = selected.id;
//     } else {
//       selId = selected;
//     }
//     const opt = options.find((o) => o.id === selId);
//     if (opt) {
//       setSelectedLabel(opt.label);
//     } else {
//       setSelectedLabel("");
//     }
//   }, [selected, options]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [dropdownRef]);

//   const handleClick = (option) => {
//     // Here you may decide to set the entire object or just option.id.
//     // For course/Scope auto-set values use the full object.
//     setSelected(option);
//     setIsActive(false);
//     setSelectedLabel(option.label);
//   };

//   return (
//     <div
//       className={`dropdown-CB ${className}`}
//       style={{ width, ...style }}
//       ref={dropdownRef}
//     >
//       <label className="dropdown-CB-label">
//         {label}
//         {isRequired && <span>*</span>}
//       </label>
//       <div className="dropdown-btn" onClick={() => setIsActive(!isActive)}>
//         {selectedLabel}
//         <img src={DropDownIcon} alt="dropdown-icon" />
//       </div>
//       {isActive && (
//         <div className="dropdown-content-CBV2" style={{ width: customWidth, top: customTop }}>
//           {options.map((option) => (
//             <div
//               key={option.id}
//               className="dropdown-item-CBV2"
//               onClick={() => handleClick(option)}
//             >
//               {option.label}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useState, useRef, useEffect } from "react";
import DropDownIcon from "../../../Assets/Images/CreateBatch/icon-dropdown-menu.png";

export default function DropDown({
  width,
  label,
  selected,
  setSelected,
  options,
  customWidth,
  customTop,
  isRequired,
  style,
  className,
  disabled = false, // ✅ new prop
}) {
  const [isActive, setIsActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const dropdownRef = useRef(null);

  // Set label on selected change
  useEffect(() => {
    let selId;
    if (selected && typeof selected === "object") {
      selId = selected.id;
    } else {
      selId = selected;
    }
    const opt = options.find((o) => o.id === selId);
    setSelectedLabel(opt ? opt.label : "");
  }, [selected, options]);

  // Close on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleClick = (option) => {
    if (disabled) return;
    setSelected(option);
    setIsActive(false);
    setSelectedLabel(option.label);
  };

  const toggleDropdown = () => {
    if (!disabled) setIsActive(!isActive);
  };

  return (
    <div
      className={`dropdown-CB ${className}`}
      style={{
        width,
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "auto",
        ...style,
      }}
      ref={dropdownRef}
    >
      <label className="dropdown-CB-label">
        {label}
        {isRequired && <span>*</span>}
      </label>
      <div className="dropdown-btn" onClick={toggleDropdown}>
        {selectedLabel}
        <img src={DropDownIcon} alt="dropdown-icon" />
      </div>
      {isActive && (
        <div
          className="dropdown-content-CBV2"
          style={{ width: customWidth, top: customTop }}
        >
          {options.map((option) => (
            <div
              key={option.id}
              className="dropdown-item-CBV2"
              onClick={() => handleClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
